import React, { Fragment } from 'react';
import { Field } from 'formik';
import Fieldset from '../fieldset';
import Error from './validationError';
import { CheckboxWithLabel } from '../checkbox';
import { SelectionHiglighter } from './style';

const DeliveryAddress = ({ values }) => (
  <Fragment>
    <SelectionHiglighter
      selected={values.customer_delivery_address_eq_invoice_address}
    >
      <Field
        name="customer_delivery_address_eq_invoice_address"
        render={({ field }) => (
          <CheckboxWithLabel
            label="Die Lieferadresse entspricht der Rechnungsadresse"
            {...field}
            checked={field.value}
          />
        )}
      />
    </SelectionHiglighter>

    <Fieldset
      heading="Lieferadresse"
      disabled={values.customer_delivery_address_eq_invoice_address}
    >
      <Field
        name="customer_delivery_address.street"
        render={({ field }) => (
          <Fieldset.TextInput
            {...field}
            label="Straße"
            disabled={values.customer_delivery_address_eq_invoice_address}
          />
        )}
      />
      <Error name="customer_delivery_address.street" />
      <Field
        name="customer_delivery_address.zip"
        render={({ field }) => (
          <Fieldset.TextInput
            {...field}
            label="PLZ"
            disabled={values.customer_delivery_address_eq_invoice_address}
          />
        )}
      />
      <Error name="customer_delivery_address.zip" />
      <Field
        name="customer_delivery_address.city"
        render={({ field }) => (
          <Fieldset.TextInput
            {...field}
            label="Stadt"
            disabled={values.customer_delivery_address_eq_invoice_address}
          />
        )}
      />
      <Error name="customer_delivery_address.city" />
      <Field
        name="customer_delivery_address.country"
        render={({ field }) => (
          <Fieldset.TextInput
            {...field}
            label="Land"
            disabled={values.customer_delivery_address_eq_invoice_address}
          />
        )}
      />
      <Error name="customer_delivery_address.country" />
    </Fieldset>
  </Fragment>
);

export default DeliveryAddress;



// WEBPACK FOOTER //
// ./src/components/orderformwizard/deliveryAddress.js